import { PUBLIC_PAGE_ROUTES } from '@/app/lib/publicRoutes'

/**
 * True when the pathname is a public (unauthenticated) page under a company slug,
 * e.g. career site or candidate apply. Keep aligned with CompanyContext redirect logic.
 */
export function isPublicPageRoute(pathname: string | null): boolean {
    if (!pathname) return false
    return PUBLIC_PAGE_ROUTES.some((route) => new RegExp(route).test(pathname))
}
